import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import withModal from '../../../../../../../../../components/global/modal/withModal';
import { sortPrintPackageItems } from '../../../../../../../../../util/print-packages';
import Button from '../../../../../../../../../components/global/Button';
import ContextualString from '../../../../../../../../../components/contextual/ContextualString';
import { DIGITAL_DOWNLOADS_MODE } from '../../../../../../../../../constants/print-packages';
import { getAsset } from '../../../../../../../../../util/assets';
import { getPrintPackageItemListingLabel } from '../AlbumPrintPackageOption/helpers';

const propTypes = {
  className: PropTypes.string,
  albumPrintPackage: PropTypes.shape({
    id: PropTypes.string.isRequired,
    print_package: PropTypes.shape({
      id: PropTypes.string.isRequired,
      price: PropTypes.shape({
        value: PropTypes.number.isRequired,
      }).isRequired,
      discount_price: PropTypes.shape({
        value: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  subscriptionItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

const PrintPackageContentsModal = ({
  className,
  albumPrintPackage,
  onClose,
  subscriptionItem,
}) => {
  const classes = classNames({
    'print-package-contents-modal-body': true,
    [className]: !!className,
  });

  const printPackage = albumPrintPackage.print_package;
  const printPackageItems = sortPrintPackageItems(printPackage.items.records);

  return (
    <div className={classes}>
      <img
        src={
          printPackage?.preview_asset_image?.url ??
          getAsset('/icon-package-3d.svg')
        }
        alt=""
        className="mb-2"
      />
      <p className="text-black text-dark mb-1">
        Digital Photo Pass + Print Package Bundle!
      </p>
      <p>
        Purchase the{' '}
        <ContextualString
          id="purchaseSubscriptionText"
          defaultMessage="Photo Pass"
          type={subscriptionItem.type}
          subtype={subscriptionItem.album_subtype}
        />{' '}
        with a Print Package of your fav photo at a discount!
      </p>

      <p>Your Print Package includes:</p>
      <ul className="album-print-package-option-items-checked text-dark text-bold">
        {printPackageItems.map(printPackageItem => (
          <li key={printPackageItem.id}>
            {getPrintPackageItemListingLabel(printPackageItem)}
          </li>
        ))}

        {printPackage.digital_downloads_mode ===
          DIGITAL_DOWNLOADS_MODE.INCLUDED && (
          <li className="text-bold text-italic">
            Includes Hi-Res Download for the chosen photo
          </li>
        )}
      </ul>

      <Button
        btnStyle="link"
        btnBlock
        className="mt-2 text-center"
        onClick={onClose}
      >
        Dismiss
      </Button>
    </div>
  );
};

PrintPackageContentsModal.propTypes = propTypes;

export default withModal(PrintPackageContentsModal, {
  hideHeader: true,
  dismissible: false,
  size: 'sm',
});
